import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
	async getMinimalCCMRecordsByPatientId (patientId) {
		const response = await _axios.get(`/ccmrecord/getminccmrecordbypatientid/${patientId}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting CCM record');
	},
	async getCCMRecordsByPatientId (patientId) {
		const response = await _axios.get(`/ccmrecord/getccmrecordbypatientid/${patientId}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting CCM record');
	},
	async getCCMRecordsByHospitalId (hospitalId) {
		const response = await _axios.get(`/ccmrecord/getccmrecordbyhospitalid/${hospitalId}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting CCM record');
	},
	async getCCMRecord (id) {
		const response = await _axios.get(`/ccmrecord/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting CCM record');
	},
	async updateCCMRecord (id, body) {
		const response = await _axios.put(`/ccmrecord/${id}`, body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error updating CCM record');
	},
	async deleteCCMRecord (id) {
		const response = await _axios.delete(`/ccmrecord/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error deleting CCM record');
	},
	async getAllConditionsTemplates () {
		const response = await _axios.get('/ccmrecord/getallconditionstemplates');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting all condition templates');
	},

	async getAllCarePlanTypes () {
		const response = await _axios.get('/ccmrecord/getallcareplantypes');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting all care plan types');
	},

	async getAllCarePlanStatuses () {
		const response = await _axios.get('/ccmrecord/getallcareplanstatuses');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting all care plan statuses');
	},

	async getSocialDeterminantsTemplate () {
		const response = await _axios.get('/ccmrecord/getsocialdeterminantstemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting social determinants template');
	},

	async getComplexDecisionMakingTemplate () {
		const response = await _axios.get('/ccmrecord/getcomplexdecisionmakingtemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting complex decision making template');
	},

	async getFunctionalStatusTemplate () {
		const response = await _axios.get('/ccmrecord/getfunctionalstatustemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting functional status template');
	},

	async getAllDiagnosisTypes () {
		const response = await _axios.get('/ccmrecord/getalldiagnosistypes');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting all diagnosis types');
	},

	async getMedicationFrequencies () {
		const response = await _axios.get('/ccmrecord/getmedicationfrequencies');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting medication frequencies');
	},

	async getMedicationEventTypeOption () {
		const response = await _axios.get('/ccmrecord/getmedicationeventtypeoption');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting medication event type option');
	},

	async getConditionSeverityOption () {
		const response = await _axios.get('/ccmrecord/getconditionseverityoption');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting condition severity option');
	},

	async getConditionReactionOption () {
		const response = await _axios.get('/ccmrecord/getallergenreactionoptionstemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting condition reaction option');
	},

	async getConditionAllergenOption () {
		const response = await _axios.get('/ccmrecord/getallergenoptionstemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting condition allergen option');
	},

	async getConditionEventTypeOption () {
		const response = await _axios.get('/ccmrecord/getconditioneventtypeoption');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting condition event type option');
	},

	async getMedicalNoteTitleOption () {
		const response = await _axios.get('/ccmrecord/getmedicalnotetitleoption');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting medical note title option');
	},

	async getMedicalNoteTypeOption () {
		const response = await _axios.get('/ccmrecord/getmedicalnotetypeoption');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting medical note type option');
	},

	async getVitalTypeOptionTemplate () {
		const response = await _axios.get('/ccmrecord/getvitaltypeoptiontemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting vital type option template');
	},

	async getVitalUnitOptionTemplate () {
		const response = await _axios.get('/ccmrecord/getvitalunitoptiontemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting vital unit option template');
	},

	async getObservationCategoryOptionsTemplate () {
		const response = await _axios.get('/ccmrecord/getobservationcategoryoptionstemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting observation category options template');
	},

	async getMedicalRoleOptionTemplate () {
		const response = await _axios.get('/ccmrecord/getmedicalroleoptiontemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting medical role option template');
	},

	async getVaccineNameTemplate () {
		const response = await _axios.get('/ccmrecord/getvaccinenametemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting vaccine name template');
	},

	async getVaccineSiteTemplate () {
		const response = await _axios.get('/ccmrecord/getvaccinesitetemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting vaccine site template');
	},

	async getVaccineRouteTemplate () {
		const response = await _axios.get('/ccmrecord/getvaccineroutetemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting vaccine route template');
	},

	async getVaccineDoseTemplate () {
		const response = await _axios.get('/ccmrecord/getvaccinedosetemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting vaccine dose template');
	},

	async getVaccineManufacturerTemplate () {
		const response = await _axios.get('/ccmrecord/getvaccinemanufacturertemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting vaccine manufacturer template');
	},

	async getImagingModalityTemplate () {
		const response = await _axios.get('/ccmrecord/getimagingmodalitytemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting imaging modality template');
	},

	async getImagingBodyPartTemplate () {
		const response = await _axios.get('/ccmrecord/getimagingbodyparttemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting imaging body part template');
	},

	async getLabPanelGroupTemplate () {
		const response = await _axios.get('/ccmrecord/getlabpanelgrouptemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting lab panel group template');
	},

	async getLabSpecimenTypeTemplate () {
		const response = await _axios.get('/ccmrecord/getlabspecimentypetemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting lab specimen type template');
	},

	async getLabInterpretationTemplate () {
		const response = await _axios.get('/ccmrecord/getlabinterpretationtemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting lab interpretation template');
	},

	async getLabUnitTemplate () {
		const response = await _axios.get('/ccmrecord/getlabunittemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting lab unit template');
	},

	async getLabCriticalFlagTemplate () {
		const response = await _axios.get('/ccmrecord/getlabcriticalflagtemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting lab critical flag template');
	},

	async getLabSourceTemplate () {
		const response = await _axios.get('/ccmrecord/getlabsourcetemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting lab source template');
	},

	async getDocumentTypeTemplate () {
		const response = await _axios.get('/ccmrecord/getdocumenttypetemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting document type template');
	},

	async getConsentTypeMethodTemplate () {
		const response = await _axios.get('/ccmrecord/getconsenttypemethodtemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting consent type method template');
	},

	async getConsentTypeTemplate () {
		const response = await _axios.get('/ccmrecord/getconsenttypetemplate');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting consent type template');
	},

	async getCCMReportDataForMonthByPatientId (data) {
		const { patientId, byMonth, byYear, ccmRecordId } = data;
		const response = await _axios.get(`/ccmrecord/getccmreportdataformonthforpatientid/${patientId}`, { headers: { byMonth, byYear, ccmRecordId } });
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting ccm report data for month for patientid template');
	},

	async addCCMRecord (body) {
		const response = await _axios.post('/ccmrecord', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error adding CCM record');
	},

	async updateSocialDeterminants (id, body) {
		const response = await _axios.put(`/ccmrecord/setsocialdeterminants/${id}`, body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error updating social determinants');
	},

	async updateComplexDecisionMaking (id, body) {
		const response = await _axios.put(`/ccmrecord/setcomplexdecisionmaking/${id}`, body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error updating complex decision making');
	},

	async updateFunctionalStatus (id, body) {
		const response = await _axios.put(`/ccmrecord/setfunctionalstatus/${id}`, body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error updating functional status');
	},
};
